<template>
  <b-modal
    :id="modalId"
    v-model="syncVisible"
    modal-class="emp-export-queue-modal"
    content-class="border-0"
    centered
    hide-header
    body-class="pt-4 px-4 pb-2"
    footer-class="emp-export-queue-modal__footer border-0 pt-0 pb-4 px-4"
    @hidden="onHidden"
  >
    <h5 class="emp-export-queue-modal__title">{{ title }}</h5>
    <p class="emp-export-queue-modal__sub">{{ subtitle }}</p>
    <template #modal-footer>
      <b-button class="emp-export-queue-modal__ok" type="button" @click="close">
        {{ okText }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
/**
 * 导出类信息弹窗：白底、圆角、紫红主按钮（样式见 emp-export-queue-modal.scss，已在 main.js 全局引入）。
 * 与 EmpDownloadStatusToast / 操作日志导出配套；任意页可 <EmpExportInfoModal modal-id="..." /> + $bvModal.show(id)。
 */
export default {
  name: "EmpExportInfoModal",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    /** 与 $bvModal.show('xxx') 一致 */
    modalId: {
      type: String,
      required: true,
    },
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    okText: {
      type: String,
      default: "OK",
    },
  },
  computed: {
    syncVisible: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", Boolean(v));
      },
    },
  },
  methods: {
    onHidden() {
      this.$emit("input", false);
    },
    close() {
      this.syncVisible = false;
    },
  },
};
</script>
